import type { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "@/components/layout/protected-route";
import { ManagePortfolioPage } from "./pages/manage-portfolio";
import { PublicPortfolioPage } from "./pages/public-portfolio";

export const portfolioRoutes: RouteObject[] = [
	{
		path: "/portfolio",
		element: (
			<ProtectedRoute requireUserType="designer">
				<ManagePortfolioPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/portfolio/:slug",
		element: <PublicPortfolioPage />,
	},
];
